class FacetFiltersForm extends HTMLElement {
    constructor() {
      super();
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
  
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 800);
  
      this.initializeFacets();
    }
  
    initializeFacets() {
      const facetForm = this.querySelector('form');
      if (facetForm) {
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      }
  
      const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
      if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  
      // Listen for filter changes
      this.addEventListener('change', this.updateGridLayout.bind(this));
      
      // Listen for filter removal button clicks
      document.addEventListener('click', (event) => {
        if (event.target.closest('.active-facets__button')) {
          this.updateGridLayout();
        }
      });
  
      // Initialize filter button
      this.initializeFilterButton();
  
      // Initialize sorting
      this.initializeSorting();
  
      // Listen for window resize
      window.addEventListener('resize', this.handleResize.bind(this));
      
      // Initialize on first load
      this.handleResize();
  
      // Initialize mobile filters
      this.initializeMobileFacets();
    }
  
    initializeSorting() {
      const sortForm = document.getElementById('FacetSortForm');
      if (sortForm) {
        // Remove old listener
        const newSortForm = sortForm.cloneNode(true);
        sortForm.parentNode.replaceChild(newSortForm, sortForm);
  
        // Add new listener
        newSortForm.addEventListener('change', (event) => {
          event.preventDefault();
          const formData = new FormData(newSortForm);
          let searchParams = new URLSearchParams(formData).toString();
          
          // Get current filter parameters
          const filterForm = document.querySelector('#FacetFiltersForm');
          if (filterForm) {
            const filterData = new FormData(filterForm);
            const filterParams = new URLSearchParams(filterData).toString();
            if (filterParams) {
              searchParams = `${searchParams}&${filterParams}`;
            }
          }
          
          // Keep current URL parameters
          const currentParams = new URLSearchParams(window.location.search);
          currentParams.forEach((value, key) => {
            if (key !== 'sort_by' && !searchParams.includes(key)) {
              searchParams = `${searchParams}&${key}=${value}`;
            }
          });
          
          FacetFiltersForm.renderPage(searchParams, event, true);
        });
      }
    }
  
    initializeFilterButton() {
      const filterButton = document.querySelector('.filter-toggle-button');
      if (filterButton) {
        filterButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          filterButton.classList.toggle('active');
          this.toggleFilter();
        });
      }
    }
  
    handleResize() {
      const isTablet = window.innerWidth < 990 && window.innerWidth >= 750;
      const filterPanel = document.querySelector('.facets-wrapper');
      const productGrid = document.getElementById('product-grid');
      
      if (productGrid) {
        const isActive = filterPanel.classList.contains('active');
        
        if (isActive) {
          // Panel is open
          if (isTablet) {
            productGrid.style.gridTemplateColumns = 'repeat(2, 1fr)';
          } else {
            productGrid.style.gridTemplateColumns = 'repeat(3, 1fr)';
          }
        } else {
          // Panel is closed
          if (isTablet) {
            productGrid.style.gridTemplateColumns = 'repeat(3, 1fr)';
          } else {
            productGrid.style.gridTemplateColumns = 'repeat(4, 1fr)';
          }
        }
      }
    }
  
    toggleFilter() {
      const isTablet = window.innerWidth < 990 && window.innerWidth >= 750;
      const filterPanel = document.querySelector('.facets-wrapper');
      const productGrid = document.getElementById('product-grid');
      
      if (filterPanel && productGrid) {
        const isActive = filterPanel.classList.contains('active');
        
        if (isActive) {
          // Close filter panel
          filterPanel.classList.remove('active');
          productGrid.classList.remove('filter-active');
          
          // Restore correct column layout
          if (isTablet) {
            productGrid.style.gridTemplateColumns = 'repeat(3, 1fr)';
          } else {
            productGrid.style.gridTemplateColumns = 'repeat(4, 1fr)';
          }
        } else {
          // Open filter panel
          filterPanel.classList.add('active');
          productGrid.classList.add('filter-active');
          
          // Set correct column layout
          if (isTablet) {
            productGrid.style.gridTemplateColumns = 'repeat(2, 1fr)';
          } else {
            productGrid.style.gridTemplateColumns = 'repeat(3, 1fr)';
          }
        }
      }
    }
  
    updateGridLayout() {
      const isTablet = window.innerWidth < 990 && window.innerWidth >= 750;
      const filterPanel = document.querySelector('.facets-wrapper');
      const productGrid = document.getElementById('product-grid');
      const activeFilters = document.querySelectorAll('.active-facets__button');
      
      if (productGrid) {
        if (activeFilters.length > 0 || filterPanel.classList.contains('active')) {
          filterPanel.classList.add('active');
          productGrid.classList.add('filter-active');
          
          // Set correct column layout
          if (isTablet) {
            productGrid.style.gridTemplateColumns = 'repeat(2, 1fr)';
          } else {
            productGrid.style.gridTemplateColumns = 'repeat(3, 1fr)';
          }
        } else {
          filterPanel.classList.remove('active');
          productGrid.classList.remove('filter-active');
          
          // Restore correct column layout
          if (isTablet) {
            productGrid.style.gridTemplateColumns = 'repeat(3, 1fr)';
          } else {
            productGrid.style.gridTemplateColumns = 'repeat(4, 1fr)';
          }
        }
      }
    }
  
    static setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
        if (searchParams === FacetFiltersForm.searchParamsPrev) return;
        FacetFiltersForm.renderPage(searchParams, null, false);
      };
      window.addEventListener('popstate', onHistoryChange);
    }
  
    static toggleActiveFacets(disable = true) {
      document.querySelectorAll('.js-facet-remove').forEach((element) => {
        element.classList.toggle('disabled', disable);
      });
    }
  
    static renderPage(searchParams, event, updateURLHash = true) {
      FacetFiltersForm.searchParamsPrev = searchParams;
      const sections = FacetFiltersForm.getSections();
      const countContainer = document.getElementById('ProductCount');
      const countContainerDesktop = document.getElementById('ProductCountDesktop');
      const loadingSpinners = document.querySelectorAll(
        '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
      );
      loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
      document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
      if (countContainer) {
        countContainer.classList.add('loading');
      }
      if (countContainerDesktop) {
        countContainerDesktop.classList.add('loading');
      }
  
      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;
  
        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
          : FacetFiltersForm.renderSectionFromFetch(url, event);
      });
  
      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }
  
    static renderSectionFromFetch(url, event) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
          
          // Reinitialize component after refresh
          const facetFiltersForm = document.querySelector('facet-filters-form');
          if (facetFiltersForm) {
            facetFiltersForm.initializeFacets();
          }
          
          if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        });
    }
  
    static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
      
      // Reinitialize component after refresh
      const facetFiltersForm = document.querySelector('facet-filters-form');
      if (facetFiltersForm) {
        facetFiltersForm.initializeFacets();
      }
      
      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    }
  
    static renderProductGridContainer(html) {
      document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('ProductGridContainer').innerHTML;
  
      document
        .getElementById('ProductGridContainer')
        .querySelectorAll('.scroll-trigger')
        .forEach((element) => {
          element.classList.add('scroll-trigger--cancel');
        });
    }
  
    static renderProductCount(html) {
      const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
      const container = document.getElementById('ProductCount');
      const containerDesktop = document.getElementById('ProductCountDesktop');
      container.innerHTML = count;
      container.classList.remove('loading');
      if (containerDesktop) {
        containerDesktop.innerHTML = count;
        containerDesktop.classList.remove('loading');
      }
      const loadingSpinners = document.querySelectorAll(
        '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
      );
      loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    }
  
    static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
        '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
      );
      const facetDetailsElementsFromDom = document.querySelectorAll(
        '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
      );
  
      // Remove facets that are no longer returned from the server
      Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
        if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
          currentElement.remove();
        }
      });
  
      const matchesId = (element) => {
        const jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? element.id === jsFilter.id : false;
      };
  
      const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
      const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);
  
      facetsToRender.forEach((elementToRender, index) => {
        const currentElement = document.getElementById(elementToRender.id);
        // Element already rendered in the DOM so just update the innerHTML
        if (currentElement) {
          document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
        } else {
          if (index > 0) {
            const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
            // Same facet type (eg horizontal/vertical or drawer/mobile)
            if (elementToRender.className === previousElementClassName) {
              document.getElementById(previousElementId).after(elementToRender);
              return;
            }
          }
  
          if (elementToRender.parentElement) {
            document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
          }
        }
      });
  
      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);
  
      if (countsToRender) {
        const closestJSFilterID = event.target.closest('.js-filter').id;
  
        if (closestJSFilterID) {
          FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
          FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));
  
          const newFacetDetailsElement = document.getElementById(closestJSFilterID);
          const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
            ? `.mobile-facets__close-button`
            : `.facets__summary`;
          const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
  
          const isTextInput = event.target.getAttribute('type') === 'text';
  
          if (newElementToActivate && !isTextInput) newElementToActivate.focus();
        }
      }
    }
  
    static renderActiveFacets(html) {
      const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
  
      activeFacetElementSelectors.forEach((selector) => {
        const activeFacetsElement = html.querySelector(selector);
        if (!activeFacetsElement) return;
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      });
  
      FacetFiltersForm.toggleActiveFacets(false);
      
      // Update layout after rendering active filters
      const facetFiltersForm = document.querySelector('facet-filters-form');
      if (facetFiltersForm) {
        facetFiltersForm.updateGridLayout();
      }
    }
  
    static renderAdditionalElements(html) {
      const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
  
      mobileElementSelectors.forEach((selector) => {
        if (!html.querySelector(selector)) return;
        document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      });
  
      document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    }
  
    static renderCounts(source, target) {
      const targetSummary = target.querySelector('.facets__summary');
      const sourceSummary = source.querySelector('.facets__summary');
  
      if (sourceSummary && targetSummary) {
        targetSummary.outerHTML = sourceSummary.outerHTML;
      }
  
      const targetHeaderElement = target.querySelector('.facets__header');
      const sourceHeaderElement = source.querySelector('.facets__header');
  
      if (sourceHeaderElement && targetHeaderElement) {
        targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
      }
  
      const targetWrapElement = target.querySelector('.facets-wrap');
      const sourceWrapElement = source.querySelector('.facets-wrap');
  
      if (sourceWrapElement && targetWrapElement) {
        const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
        if (isShowingMore) {
          sourceWrapElement
            .querySelectorAll('.facets__item.hidden')
            .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
        }
  
        targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
      }
    }
  
    static renderMobileCounts(source, target) {
      const targetFacetsList = target.querySelector('.mobile-facets__list');
      const sourceFacetsList = source.querySelector('.mobile-facets__list');
  
      if (sourceFacetsList && targetFacetsList) {
        targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
      }
    }
  
    static updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }
  
    static getSections() {
      return [
        {
          section: document.getElementById('product-grid').dataset.id,
        },
      ];
    }
  
    createSearchParams(form) {
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    }
  
    onSubmitForm(searchParams, event) {
      FacetFiltersForm.renderPage(searchParams, event);
    }
  
    onSubmitHandler(event) {
      event.preventDefault();
      const sortFilterForms = document.querySelectorAll('facet-filters-form form');
      if (event.srcElement.className == 'mobile-facets__checkbox') {
        const searchParams = this.createSearchParams(event.target.closest('form'));
        this.onSubmitForm(searchParams, event);
      } else {
        const forms = [];
        const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
  
        sortFilterForms.forEach((form) => {
          if (!isMobile) {
            if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
              forms.push(this.createSearchParams(form));
            }
          } else if (form.id === 'FacetFiltersFormMobile') {
            forms.push(this.createSearchParams(form));
          }
        });
        this.onSubmitForm(forms.join('&'), event);
      }
    }
  
    onActiveFilterClick(event) {
      event.preventDefault();
      FacetFiltersForm.toggleActiveFacets();
      const url =
        event.currentTarget.href.indexOf('?') == -1
          ? ''
          : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
      FacetFiltersForm.renderPage(url);
    }
  
    initializeMobileFacets() {
      const mobileFacets = document.querySelector('.mobile-facets__wrapper');
      if (!mobileFacets) return;
  
      const details = mobileFacets.querySelectorAll('.mobile-facets__details');
      details.forEach(detail => {
        const summary = detail.querySelector('.mobile-facets__summary');
        const submenu = detail.querySelector('.mobile-facets__submenu');
        
        if (summary && submenu) {
          // Remove old listener
          const newSummary = summary.cloneNode(true);
          summary.parentNode.replaceChild(newSummary, summary);
          
          newSummary.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            
            // Close all other open submenus
            details.forEach(otherDetail => {
              if (otherDetail !== detail && otherDetail.hasAttribute('open')) {
                otherDetail.removeAttribute('open');
              }
            });
  
            // Toggle current submenu
            if (detail.hasAttribute('open')) {
              detail.removeAttribute('open');
            } else {
              detail.setAttribute('open', '');
            }
          });
  
          // Handle close button
          const closeButton = submenu.querySelector('.mobile-facets__close-button');
          if (closeButton) {
            // Remove old listener
            const newCloseButton = closeButton.cloneNode(true);
            closeButton.parentNode.replaceChild(newCloseButton, closeButton);
            
            newCloseButton.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              detail.removeAttribute('open');
            });
          }
        }
      });
    }
  }
  
  FacetFiltersForm.filterData = [];
  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
  customElements.define('facet-filters-form', FacetFiltersForm);
  FacetFiltersForm.setListeners();
  
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('input').forEach((element) => {
        element.addEventListener('change', this.onRangeChange.bind(this));
        element.addEventListener('keydown', this.onKeyDown.bind(this));
      });
      this.setMinAndMaxValues();
    }
  
    onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
    }
  
    onKeyDown(event) {
      if (event.metaKey) return;
  
      const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
      if (!event.key.match(pattern)) event.preventDefault();
    }
  
    setMinAndMaxValues() {
      const inputs = this.querySelectorAll('input');
      const minInput = inputs[0];
      const maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
      if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
      if (minInput.value === '') maxInput.setAttribute('data-min', 0);
      if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
    }
  
    adjustToValidValues(input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute('data-min'));
      const max = Number(input.getAttribute('data-max'));
  
      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }
  
  customElements.define('price-range', PriceRange);
  
  class FacetRemove extends HTMLElement {
    constructor() {
      super();
      const facetLink = this.querySelector('a');
      facetLink.setAttribute('role', 'button');
      facetLink.addEventListener('click', this.closeFilter.bind(this));
      facetLink.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
      });
    }
  
    closeFilter(event) {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    }
  }
  
  customElements.define('facet-remove', FacetRemove);
  